import { Fragment } from "react";
import { FormattedMessage } from "react-intl";

// Mui components
import { Box, Typography } from "@mui/material";

// Components
import { CardMessageWrapper, CardMessage } from "components/Message";
import LeadershipProfileCard from "./LeadershipProfileCard";

// Hooks
import useLeadershipProfile from "./useLeadershipProfile";

const LeadershipProfile = ({
    personId,
    shouldShowAlertMessage,
    Toolbar,
}: {
    personId: number | undefined;
    shouldShowAlertMessage: boolean;
    Toolbar?: () => JSX.Element;
}) => {
    const { leadershipProfileCards, shouldStick, cardsWrapperRef, chartWrapperRef } = useLeadershipProfile();

    return (
        <Box
            sx={{
                width: "100%",
                transition: "all .5s",
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 600 }} mb={2}>
                <FormattedMessage id="paceLabsDashbard.leftSide.title" />
            </Typography>

            <div ref={chartWrapperRef}>
                <Box position="relative" ref={cardsWrapperRef}>
                    {leadershipProfileCards.map((data, i) => {
                        return (
                            <Fragment key={i}>
                                {data.alertMessage?.shouldShowMessage && (
                                    <CardMessageWrapper sx={{ alignItems: "flex-start !important" }}>
                                        <CardMessage
                                            color="primary"
                                            title={data.alertMessage.title}
                                            content={data.alertMessage.content}
                                            actions={data.alertMessage.actions}
                                            sx={{
                                                position: shouldStick ? "sticky" : "static",
                                                top: "58vh",
                                                [`@media (min-height: 800px)`]: {
                                                    top: "70vh",
                                                },
                                            }}
                                        />
                                    </CardMessageWrapper>
                                )}
                                <LeadershipProfileCard
                                    title={data.title}
                                    content={data.content}
                                    popoverContent={data.popoverContent}
                                    onClickDetails={data.onClickDetails}
                                    bgColor={data.bgColor}
                                    shouldShowLoading={data.shouldShowLoading}
                                    shouldShowBlurred={data.shouldShowBlurred}
                                />
                            </Fragment>
                        );
                    })}
                </Box>
            </div>
        </Box>
    );
};

export default LeadershipProfile;
